<template>
  <div class="home animated fadeIn">
    <div class="row">
      <div class="col-sm-6 col-md-6">
        <div class="body">
          <SidebarView v-show="loaded" />
          <br />
          <h1>ADORA</h1>
          <p>Hi, my name is Nenne Adaora Nwodo, but everyone calls me Adora 🌟</p>
          <p>I am an Engineering Leader, AI researcher, multi published Author, and Founder of <a rel="noopener" target="_blank" href="https://nexascale.org">NexaScale</a>.</p>
          <p>If you need my bio, photos, or assets for a feature or speaking engagement, <a rel="noopener" target="_blank" href="https://drive.google.com/drive/folders/1mezxNIsHzixsCdHY1dHDLYH3i0akbDj5">click here</a>.</p>
          <p>Explore <router-link to="/books">my seven books</router-link> on cloud, DevOps, and AI.</p>

          <img src="../assets/images/home-sm-min-new.jpg" class="d-block d-sm-none img-full-width" alt="adora" />

          <br />
          
          <ul class="icons-list">
            <li>
              <a rel="noopener" target="_blank" href="https://adorahack.com"><img src="../assets/images/adorahackblack.png" class="adorahack-icon"/></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://twitter.com/adoranwodo"><i class="fab fa-twitter"></i></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://instagram.com/adorahack"><i class="fab fa-instagram"></i></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://www.youtube.com/@adora-nwodo"><i class="fab fa-youtube"></i></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://scholar.google.com/citations?user=lkk-9NUAAAAJ&hl=en"><img src="../assets/images/gscholar.svg" class="gscholar-icon"/></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://github.com/adoranwodo"><i class="fab fa-github"></i></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://www.linkedin.com/in/adoranwodo/"><i class="fab fa-linkedin-in"></i></a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="https://en.wikipedia.org/wiki/Adora_Nwodo"><i class="fab fa-wikipedia-w"></i></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 background-home-image d-none d-sm-block"></div>
    </div>
    <FooterView class="d-block d-sm-none"/>
  </div>
</template>

<script>
import SidebarView from '@/components/SidebarView.vue'
import FooterView from '@/components/FooterView.vue' 

export default {
  data() {
      return {
        loaded: false
      }
  },
  methods:{
  },
  mounted(){
      this.loaded = true;  
  },
  components: {
    SidebarView,
    FooterView
  }
}
</script>

<style scoped>
/* NEW STYLES */
.background-home-image{
  height: 100vh;
  background: url('../assets/images/home-min-new.jpg');
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
}
.home .body{
  padding: 50px;
}
.home .body h1{
  padding-top: 90px;
  padding-bottom: 50px;
}
.adorahack-icon{
  width: 17px;
  margin-bottom: 4px;
}

.gscholar-icon{
  width: 17px;
  margin-bottom: 0px;
}
.hashnode-icon{
  width: 17px;
  margin-bottom: -2px; 
}
.icons-list{
  margin-top: 50px;
  margin-bottom: 50px;
  margin-left: -40px;
}
.home .icons-list i{
  font-size: 20px;
}
.icons-list li{
  list-style-type: none;
  display: inline;
  margin-right: 10px;
}
.icons-list li img{
  margin-top: -5px;
}
.icons-list li a{
  font-size: 22px;
  color: black !important;
}
.home p a{
  color: black !important;
  text-decoration: underline;
}
.img-full-width{
  width: 100%;
}
@media (max-width: 575px) { 
  .home .body h1{
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .home .icons-list{
    margin-top: 20px;
    margin-bottom: 0px;
  }
 }
</style>

